const opts = { credentials: "include", headers: { Accept: "application/json" } };

async function read(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "Permintaan gagal.");
  return data;
}

export function fetchPublicConfig() {
  return fetch("/api/public-config", opts).then(read);
}

export function fetchCatalog() {
  return fetch("/api/catalog", opts).then(read);
}

export function unlockVisitor(password) {
  return fetch("/api/gate", {
    ...opts,
    method: "POST",
    headers: { ...opts.headers, "Content-Type": "application/json" },
    body: JSON.stringify({ password }),
  }).then(read);
}

export function adminLogin(password) {
  return fetch("/api/admin/login", {
    ...opts,
    method: "POST",
    headers: { ...opts.headers, "Content-Type": "application/json" },
    body: JSON.stringify({ password }),
  }).then(read);
}

export function adminLogout() {
  return fetch("/api/admin/logout", { ...opts, method: "POST" }).then(read);
}

export function adminMe() {
  return fetch("/api/admin/me", opts).then(read);
}

export function adminSettings() {
  return fetch("/api/admin/settings", opts).then(read);
}

export function saveAdminSettings(payload) {
  return fetch("/api/admin/settings", {
    ...opts,
    method: "POST",
    headers: { ...opts.headers, "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).then(read);
}

export function saveOpenAiKey(key) {
  return fetch("/api/admin/openai-key", {
    ...opts,
    method: "POST",
    headers: { ...opts.headers, "Content-Type": "application/json" },
    body: JSON.stringify({ key }),
  }).then(read);
}

export function forgotPassword({ kind }) {
  return fetch("/api/forgot", {
    ...opts,
    method: "POST",
    headers: { ...opts.headers, "Content-Type": "application/json" },
    body: JSON.stringify({ kind }),
  }).then(read);
}

export function inspectReset(token) {
  return fetch(`/api/reset/check?token=${encodeURIComponent(token)}`, opts).then(read);
}

export function completeReset({ token, password }) {
  return fetch("/api/reset", {
    ...opts,
    method: "POST",
    headers: { ...opts.headers, "Content-Type": "application/json" },
    body: JSON.stringify({ token, password }),
  }).then(read);
}

export function saveRecovery(payload) {
  return fetch("/api/admin/recovery", {
    ...opts,
    method: "POST",
    headers: { ...opts.headers, "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).then(read);
}

export function testRecoveryEmail() {
  return fetch("/api/admin/test-email", { ...opts, method: "POST" }).then(read);
}

export function savePasswords(payload) {
  return fetch("/api/admin/passwords", {
    ...opts,
    method: "POST",
    headers: { ...opts.headers, "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).then(read);
}

export function adminCatalog() {
  return fetch("/api/admin/catalog", opts).then(read);
}

export function saveFamily(payload) {
  return fetch("/api/admin/family", {
    ...opts,
    method: "POST",
    headers: { ...opts.headers, "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).then(read);
}

export function deleteFamily(id) {
  return fetch("/api/admin/family/delete", {
    ...opts,
    method: "POST",
    headers: { ...opts.headers, "Content-Type": "application/json" },
    body: JSON.stringify({ id }),
  }).then(read);
}

export function saveVariant(payload) {
  return fetch("/api/admin/variant", {
    ...opts,
    method: "POST",
    headers: { ...opts.headers, "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).then(read);
}

export function deleteVariant(familyId, id) {
  return fetch("/api/admin/variant/delete", {
    ...opts,
    method: "POST",
    headers: { ...opts.headers, "Content-Type": "application/json" },
    body: JSON.stringify({ familyId, id }),
  }).then(read);
}

export function uploadVariantImage({ familyId, variantId, file }) {
  const body = new FormData();
  body.append("image", file, file.name);
  body.append("filename", file.name);
  body.append("familyId", familyId);
  body.append("variantId", variantId);
  return fetch("/api/admin/upload", { credentials: "include", method: "POST", body }).then(read);
}

export function clearEditCache() {
  return fetch("/api/admin/cache-clear", { ...opts, method: "POST" }).then(read);
}

export function formatUsd(value) {
  if (typeof value !== "number") return "—";
  return `$${value.toFixed(3)}`;
}
